import "./ProjectDd.scss";
import Offcanvas from "react-bootstrap/Offcanvas";
import useExecuteContext from "../../utils/hooks/executeContext";
import { Swiper, SwiperSlide } from "swiper/react";
import { baseUrl } from "../../utils/apiData";
import { IoLocationSharp } from "react-icons/io5";
import { GoArrowLeft } from "react-icons/go";
import { GoArrowRight } from "react-icons/go";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const ProjectDd = () => {
  const { projects, projectDd, setProjectDd } = useExecuteContext();
  const navigate = useNavigate();
  const slideRef = useRef();

  const prevHandler = () => {
    slideRef?.current?.swiper?.slidePrev();
  };
  const nextHandler = () => {
    slideRef?.current?.swiper?.slideNext();
  };

  const [btn, setBtn] = useState("Builder");
  const [dataListr, setDataList] = useState([]);

  useEffect(() => {
    setDataList(projects?.filter((ele) => ele?.project_category === "Builder" && ele?.category?.name === "Ongoing"));
  }, [projects?.length]);

  return (
    <Offcanvas
      className="projec_dd"
      placement="top"
      show={projectDd}
      onHide={() => setProjectDd(false)}
    >
      <Offcanvas.Body>
        <section className="project_dd_sec">
          <div className="content_wrap">
            <div className="dd_grid">
              {/* Tabs Line */}
              <div className="tab_line">
                <button
                  className={`underline_btn arrow_btn ${
                    btn === "Builder" ? "active" : ""
                  }`}
                  onClick={() => {
                    setBtn("Builder");
                    setDataList(
                      projects?.filter(
                        (ele) => ele?.project_category === "Builder" &&  ele?.category?.name === "Ongoing"
                      )
                    );
                  }}
                >
                  Ongoing <GoArrowRight />
                </button>

                <button
                  className={`underline_btn arrow_btn ${
                    btn === "Upcoming" ? "active" : ""
                  }`}
                  onClick={() => {
                    setBtn("Upcoming");
                    setDataList(
                      projects?.filter(
                        (ele) =>
                          ele?.project_category === "Builder" &&
                          ele?.category?.name === "Upcoming"
                      )
                    );
                  }}
                >
                  Upcoming <GoArrowRight />
                </button>

                <button
                  type="button"
                  className={`underline_btn arrow_btn ${
                    btn === "Delivered" ? "active" : ""
                  }`}
                  onClick={() => {
                    setBtn("Delivered");
                    setDataList(
                      projects?.filter(
                        (ele) =>
                          ele?.project_category === "Builder" &&
                          ele?.category?.name === "Delivered"
                      )
                    );
                  }}
                >
                  Delivered <GoArrowRight />
                </button>
                <button
                  className={`underline_btn arrow_btn ${
                    btn === "Contractor" ? "active" : ""
                  }`}
                  onClick={() => {
                    setBtn("Contractor");
                    setProjectDd(false);
                    navigate("/projects/Contractor");
                  }}
                >
                  As a Contractor
                  <GoArrowRight />
                </button>
              </div>

              {/* Project Slider */}
              <div className="project_slider">
                {dataListr?.length > 0 ? (
                  <Swiper
                    ref={slideRef}
                    loop={false}
                    spaceBetween={16}
                    slidesPerView={2.5}
                    breakpoints={{
                      1200: {
                        slidesPerView: 2.5,
                      },
                      100: {
                        slidesPerView: 2,
                      },
                    }}
                  >
                    {dataListr?.map((data, l) => {
                      return (
                        <SwiperSlide key={`${data?._id}/${l}`}>
                          <div className="project_slide">
                            <div className="img_wrap">
                              <img
                                src={`${baseUrl}/${data?.image}`}
                                alt="Award"
                              />
                            </div>
                            <p className="gold">{data?.name}</p>
                            <div className="info">
                         {data?.location_name &&     <p className="gold">
                                <IoLocationSharp /> {data?.location_name}
                              </p>}
                            </div>

                            {data?.project_category === "Contractor" && (
                              <p className="gold">{data?.small_description}</p>
                            )}
                            {data?.project_category !== "Contractor" && (
                              <div className="btn_line">
                                <button
                                  type="button"
                                  className="underline_btn"
                                  onClick={() => {
                                    navigate(`/project/${data?.slug}`);
                                    setProjectDd(false);
                                  }}
                                >
                                  Know More
                                </button>
                              </div>
                            )}
                          </div>
                        </SwiperSlide>
                      );
                    })}

                    {/* Ongoing Knoe More Slide */}
                    {btn === "Builder" && (
                      <SwiperSlide>
                        <div
                          className="know_more_slide"
                          onClick={() => {
                            setProjectDd(false);
                            navigate("/projects/Builder?category=Ongoing");
                          }}
                        >
                          <p>Know More</p>
                        </div>
                      </SwiperSlide>
                    )}

                    {/* Upcoming Knoe More Slide */}
                    {btn === "Upcoming" && (
                      <SwiperSlide>
                        <div
                          className="know_more_slide"
                          onClick={() => {
                            setProjectDd(false);
                            navigate("/projects/Builder?category=Upcoming");
                          }}
                        >
                          <p>Know More</p>
                        </div>
                      </SwiperSlide>
                    )}

                    {/* Delivered Knoe More Slide */}

                    {btn === "Delivered" && (
                      <SwiperSlide>
                        <div
                          className="know_more_slide"
                          onClick={() => {
                            setProjectDd(false);
                            navigate("/projects/Builder?category=Delivered");
                          }}
                        >
                          <p>Know More</p>
                        </div>
                      </SwiperSlide>
                    )}
                  </Swiper>
                ) : (
                  <p className="gold text-center mt-5">Data not found...</p>
                )}
              </div>
            </div>

            <div className="controles">
              <button type="button" onClick={prevHandler}>
                <GoArrowLeft />
              </button>
              <button type="button" onClick={nextHandler}>
                <GoArrowRight />
              </button>
            </div>
          </div>
        </section>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ProjectDd;
